import { supabase } from '../supabase';

// Helper to generate a UUID v4
const uuidv4 = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c: any) =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
};

export const trackMetaEvent = async (eventName: string, eventData?: any) => {
  try {
    let userData: any = {};
    
    // Get session to populate user data
    const { data: { session } } = await supabase.auth.getSession();
    const user = session?.user;
    
    if (user) {
      userData = {
        em: user.email,
        fn: user.user_metadata?.full_name,
        // We can fetch state from profile if needed, but this is a good start
      };
      
      // If we have profile data in metadata
      if (user.user_metadata?.state) {
        userData.st = user.user_metadata.state;
      }
      if (user.user_metadata?.phone) {
        userData.ph = user.user_metadata.phone;
      }
    }

    if (eventData?.user_data) {
      userData = { ...userData, ...eventData.user_data };
    }

    const eventId = uuidv4();

    // 1. Fire Meta Pixel natively
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', eventName, eventData?.custom_data || {}, { eventID: eventId });
    }

    // 2. Fire TikTok Pixel natively
    if (typeof window !== 'undefined' && (window as any).ttq) {
      (window as any).ttq.track(eventName, eventData?.custom_data || {}, { event_id: eventId });
    }

    const payload = {
      event_name: eventName,
      event_id: eventId,
      event_source_url: window.location.href,
      user_data: userData,
      custom_data: eventData?.custom_data
    };

    // Send async, don't await response to avoid blocking UI
    fetch('/api/meta-conversions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).catch(err => console.error("Error sending meta event:", err));
    
  } catch (error) {
    console.error("Failed to track Meta Event:", error);
  }
};
